module.exports = "<router-outlet></router-outlet>\r\n<toaster-container></toaster-container>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main